// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__xFfF8","footer":"ModalCreateQualiphyProcedure_footer__1pGzW","additionData":"ModalCreateQualiphyProcedure_additionData__32NxA"};